import { Form, Checkbox } from 'antd';
import PropTypes from 'prop-types';
import './secciones.scss';

const SeccionAcuerdo = ({ form }) => {
  return (
    <div>
      <Form form={form} layout="horizontal">
        <div className="container-datos">
          <Form.Item name="acuerdoCOF">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ acuerdoCOF: target.checked });
              }}>
              Acuerdo COF
            </Checkbox>
          </Form.Item>
          <Form.Item name="fechaAcuerdoCOF">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ fechaAcuerdoCOF: target.checked });
              }}>
              Fecha de Acuerdo de la COF
            </Checkbox>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default SeccionAcuerdo;

SeccionAcuerdo.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func
  }).isRequired
};
